var map = {
	"./btn_google.png": "7fed",
	"./btn_google_icon.png": "0483",
	"./btn_google_signin.png": "baed",
	"./btn_google_signin_focus.png": "9e64",
	"./btn_ok.png": "4d1f",
	"./i1.png": "92c9",
	"./i5.png": "fb8f",
	"./i6.png": "286d",
	"./logo-ne.png": "858a",
	"./logo.png": "cf05",
	"./logo2.png": "5fbe",
	"./logo3.png": "d092"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";